<template>
    <div class="flex grow h-0 py-2">
        <div class="flex flex-col h-full w-full px-2">
            <card-form
                ref="cardFormRef"
                :callbacks="{ refreshData: refreshEosrcCard, saveData: saveEosrcCard, isDirty: null }"
                :meta="eosrcCardMeta"
                :to-remove-toolbar-items-names="['copy', 'edit', 'delete', 'settings']"
                :use-default-buttons="true"
                components-path="views/e-grid/eosrc-card/field-wrappers"
                @is-dirty="onIsDirty"
            />
        </div>
        <widgets-side-menu local-storage-key="eosrcWidgetList" />
        <widgets-popup :user-data="userData" />
    </div>
</template>
<script setup>
import { useStore } from 'vuex';
import CardForm from '@/components/card-component/card-form.vue';
import eosrcCardMeta from '@/views/e-grid/eosrc-card/card-meta';
import { getEosrcCard, updEosrcCard } from '@/service/e-grid-service';
import WidgetsPopup from '@/components/card-component/widgets-popup.vue';
import WidgetsSideMenu from '@/components/card-component/widgets-side-menu.vue';
import useEosrcWidgetList from '@/views/e-grid/eosrc-card/widget-list';
import { useRoute } from 'vue-router';
import { ref } from 'vue';
import {
    setIsDirtyValue,
    setTabReadyToSaveValue,
    setTabTitle,
} from '@/layouts/main-layout/components/navigation-bars-data';
// import { ContextNames, getContextGroup, saveContexts } from '@/layouts/main-layout/main-layout-data';

const store = useStore();
const route = useRoute();
const cardFormRef = ref();
const widgetList = useEosrcWidgetList();
const userData = ref();
store.dispatch('createWidgetMetaList', widgetList);

const onIsDirty = e => {
    console.log('onIsDirty', e.value, e.userData);
    userData.value = e.userData;
    const fnc = () => e.userData;
    setTabReadyToSaveValue(true);
    setIsDirtyValue(e.value, saveEosrcCard, fnc, 'eosrc-card', 'eosrc-card');
};
const refreshEosrcCard = async () => {
    const data = await getEosrcCard(route.params.id);
    if (data.result && data.success && data.data) {
        setTabTitle(`ЭО ${data.data['kindname']} ${data.data['dnum']}`);
    }
    return data;
};
const saveEosrcCard = async data => {
    return await updEosrcCard(data);
};
</script>
<script>
export default {
    name: 'eosrc-card',
};
</script>
